import router from '@/router/router';
import store from '@/store';
import {createApp} from 'vue';
import App from './App.vue';
import Default from './layouts/Default.vue';
import NoSidebar from './layouts/NoSidebar.vue';
import Extended from './layouts/Extended.vue';
import {library} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText} from '@fortawesome/vue-fontawesome';
import {
    faBars, faPowerOff, faPlusSquare,
    faUser, faUsers, faHome, faFolderOpen,
    faFileImport, faFileExport, faFileUpload,
    faFileMedicalAlt, faFileSignature, faRuler, faClipboardCheck,
    faSpinner, faSearch, faKey,
    faCheckCircle, faInfoCircle, faQuestionCircle, faExclamationCircle, faPlusCircle, faMinusCircle, faTimesCircle,
    faSave, faTimes, faEdit, faEnvelope,
    faDownload, faPaperPlane, faPlus, faInfo, faClock,
    faEye, faEyeSlash, faCog, faCogs, faPen, faTrash,
    faExclamationTriangle, faUndo, faRedo,
    faChevronUp, faChevronDown, faChevronLeft, faChevronRight,
    faStepBackward, faArrowLeft, faArrowRight, faArrowUp, faArrowDown,
    faListUl, faDatabase, faChartBar, faChartLine,
    faTachometerAlt, faMapMarkerAlt, faFile, faFolder, faFileExcel, faChartColumn,
} from '@fortawesome/free-solid-svg-icons';
import PrimeVue from 'primevue/config';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import Highcharts from 'highcharts';
import StockModule from 'highcharts/modules/stock';
import HighchartsVue from 'highcharts-vue';
import {TinyEmitter} from 'tiny-emitter';
import FloatingVue from 'floating-vue';
import VueMatomo from 'vue-matomo';
import * as functions from './helpers/functions';
import {proxyService} from '@/services'; // Importer le service pour récupérer l'utilisateur

StockModule(Highcharts);

library.add(
    faBars, faPowerOff, faPlusSquare,
    faUser, faUsers, faHome, faFolderOpen,
    faFileImport, faFileExport, faFileUpload,
    faFileMedicalAlt, faFileSignature, faRuler, faClipboardCheck,
    faSpinner, faSearch, faKey,
    faCheckCircle, faInfoCircle, faQuestionCircle, faExclamationCircle, faPlusCircle, faMinusCircle, faTimesCircle,
    faSave, faTimes, faEdit, faEnvelope,
    faDownload, faPaperPlane, faPlus, faInfo, faClock,
    faEye, faEyeSlash, faCog, faCogs, faPen, faTrash,
    faExclamationTriangle, faUndo, faRedo,
    faChevronUp, faChevronDown, faChevronLeft, faChevronRight,
    faStepBackward, faArrowLeft, faArrowRight, faArrowUp, faArrowDown,
    faListUl, faDatabase, faChartBar, faChartLine,
    faTachometerAlt, faMapMarkerAlt, faFile, faFolder, faFileExcel, faChartColumn
);

const emitter = new TinyEmitter();
const app = createApp(App);

// Enregistrer les composants
app.component('default-layout', Default);
app.component('no-sidebar-layout', NoSidebar);
app.component('extended-layout', Extended);
app.component('font-awesome-icon', FontAwesomeIcon);
app.component('font-awesome-layers', FontAwesomeLayers);
app.component('font-awesome-layers-text', FontAwesomeLayersText);
app.component('Dropdown', Dropdown);
app.component('InputText', InputText);

// Ajouter les propriétés globales
app.config.globalProperties.eventBus = emitter;
app.config.globalProperties.$functions = functions;

// Initialisation asynchrone de l'authentification
async function initializeApp() {
    // Configurer les plugins une seule fois
    app.use(store);
    app.use(router);
    app.use(PrimeVue);
    app.use(HighchartsVue);
    app.use(FloatingVue);
    app.use(VueMatomo, {
        host: process.env.VUE_APP_MATOMO_URL,
        siteId: process.env.VUE_APP_MATOMO_SITE_ID,
        router: router,
        enableLinkTracking: true,
        trackInitialView: true,
    });

    // Monter l'application

    const response = await proxyService.getUsername();
    const username = response.username || response.data?.username;
    if (username && window._paq) {
        window._paq.push(['setUserId', username]);
    }
    await store.dispatch('authentication/login', {username});
    app.mount('#app');
    const loader = document.getElementById('loader');
    if (loader) {
        loader.parentNode.removeChild(loader);
    }
}

initializeApp();


